














import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
})
export default class FileUploadDialog extends Vue {
  @Prop({default: 'ファイルアップロードダイアログ'})
  private name!: string;
  @Prop({default: 'ファイルをアップロードしますか？'})
  private message!: string;
  private アップロードファイル: File | null = null;
  private アラートメッセージ: string | null = null;

  private onFileChanged(event: any) {
    const files: FileList = event.target.files;
    if (0 === files.length) {
      return;
    }
    this.アップロードファイル = files.item(0);
    if (this.アップロードファイル && this.アップロードファイル.size > this.アップロード制限サイズ()) {
      this.アラートメッセージ = 'ファイルのアップロードは' + (this.アップロード制限サイズ() / this.メガバイト()) + 'MB 以下にしてください';
      this.$modal.show('ファイルアップロードアラートダイアログ');
    }
  }

  private アップロード可能である(): boolean {
    if (this.アップロードファイル === null) {
      return false;
    }
    if (this.アップロードファイル.size > this.アップロード制限サイズ()) {
      return false;
    }
    return true;
  }

  private アップロード制限サイズ(): number {
    return 30 * this.メガバイト(); // 30MB以上は禁止
  }

  private メガバイト(): number {
    return 1024 * 1024;
  }

  @Emit('upload')
  private アップロードする(): File | null {
    this.$modal.hide(this.name);
    const 対象ファイル = this.アップロードファイル;
    this.アップロードファイル = null;
    this.アラートメッセージ = null;
    return 対象ファイル;
  }

  private ダイアログを閉じる(): void {
    this.$modal.hide(this.name);
    this.アラートメッセージ = null;
    this.アップロードファイル = null;
  }
 }
